import {createDraftSafeSelector} from '@reduxjs/toolkit';

import quizStatuses from '../../consts/loyalty/quizStatuses';
import BADGES_CONFIG from '../../containers/ClubPage/configs/badgesConfig';
import * as loyaltyHelpers from '../../services/loyalty/loyaltyHelpers';

const selectLoyaltyState = (state) => state.loyalty;

export const selectCurrentBadgeType = createDraftSafeSelector(selectLoyaltyState, (state) => state.currentBadge);

export const selectBadgeTypeByMilestone = (milestoneType) =>
    createDraftSafeSelector(selectLoyaltyState, (state) => {
        return Object.keys(state.badges).find((badge) => state.badges[badge]?.milestones?.includes(milestoneType));
    });

export const selectBadges = createDraftSafeSelector(selectLoyaltyState, (state) => state.badges);

export const selectSortedBadges = createDraftSafeSelector(selectLoyaltyState, (state) =>
    loyaltyHelpers.filterSortedBadges(state.badges)
);

export const selectNotFinishedBadges = createDraftSafeSelector(selectLoyaltyState, (state) =>
    loyaltyHelpers.filterNotFinishedBadges(state.badges)
);

export const selectNotStartedBadges = createDraftSafeSelector(selectLoyaltyState, (state) =>
    loyaltyHelpers.filterNotStartedBadges(state.badges)
);

export const selectCompletedBadges = createDraftSafeSelector(selectLoyaltyState, (state) =>
    loyaltyHelpers.filterCompletedBadges(state.badges)
);

export const selectBadgeData = (badgeType) =>
    createDraftSafeSelector(selectLoyaltyState, (state) => ({
        ...state.badges[badgeType],
        imageSrc: BADGES_CONFIG?.[badgeType]?.imageSrc,
    }));

export const selectQuizStatus = (quizType) =>
    createDraftSafeSelector(selectLoyaltyState, (state) => state?.quizzes?.[quizType]?.status);

export const selectIsQuizInProgress = (quizType) =>
    createDraftSafeSelector(selectQuizStatus(quizType), (status) => status === quizStatuses.IN_PROGRESS);

export const selectIsQuizCompleted = (quizType) =>
    createDraftSafeSelector(selectQuizStatus(quizType), (status) => status === quizStatuses.COMPLETED);

export const selectQuizData = (quizType) =>
    createDraftSafeSelector(selectLoyaltyState, (state) => state.quizzes?.[quizType] || {});

export const selectIsLoyaltyMockEnabled = createDraftSafeSelector(
    selectLoyaltyState,
    (state) => state.isLoyaltyMockEnabled
);

export const selectConversionStatus = createDraftSafeSelector(selectLoyaltyState, (state) => state.conversionStatus);

export const selectLoyaltyUserData = createDraftSafeSelector(selectLoyaltyState, (state) => state.userData);

export const selectIsConsecutive3Days = createDraftSafeSelector(
    selectLoyaltyUserData,
    (state) => state.isConsecutive3Days
);

export const selectIsQuizAnswersCorrect = (quizType) =>
    createDraftSafeSelector(selectQuizData(quizType), (quizData) => quizData?.isAnswersCorrect);

export const selectIsQuizTimeoutError = (quizType) =>
    createDraftSafeSelector(selectQuizData(quizType), (quizData) => quizData?.isTimeoutError);

export const selectRewards = createDraftSafeSelector(selectLoyaltyState, (state) => state.rewards);

export const selectIsBadgesLoaded = createDraftSafeSelector(selectLoyaltyState, (state) => state.isBadgesLoaded);

export const selectIsBadgesInProgress = createDraftSafeSelector(
    selectLoyaltyState,
    (state) => state.isBadgesInProgress
);
